import { ReactElement } from 'react';

import { createTranslatedText } from '@dreryk/react-common';
import { Link } from '@dreryk/react-components';

const EMAIL_ADDRESS = 'wsparcieegabinet@dreryk.pl';

export const MfaRequiredEmailLink = (): ReactElement => {
   return (
      <Link
         testId={'sendEmail'}
         block={false}
         href={`mailto:${EMAIL_ADDRESS}`}
         label={createTranslatedText(EMAIL_ADDRESS)}
      />
   );
};
